import { keyframes } from '@emotion/react';
import { Button, ButtonProps, styled } from '@mui/material';
import React from 'react';

const shimmerKeyframesRight = keyframes`
    100% {
      mask-position: left;
    }
`;

const shimmerKeyframesLeft = keyframes`
    100% {
      mask-position: right;
    }
`;

// No additional props needed - using MUI's variant prop directly
type ShimmerButtonProps = ButtonProps;

const StyledShimmerButton = styled(Button)<ShimmerButtonProps>(({ theme }) => {
  return {
    mask: 'linear-gradient(-45deg, #000 40%, #0005 50%, #000 60%) left/400% 100%',
    animation: `${shimmerKeyframesLeft} 0.5s infinite linear`,
    animationIterationCount: 1,
    '&:hover': {
      animation: `${shimmerKeyframesRight} 1s infinite linear`,
      animationIterationCount: 1,
      maskPosition: 'right',
    },
    transition: theme.transitions.create(['background-color'], {
      duration: theme.transitions.duration.short,
    }),
  };
});

const ShimmerButton = React.forwardRef<HTMLButtonElement, ShimmerButtonProps>(
  ({ children, variant = 'contained', sx, ...props }, ref) => {
    return (
      <StyledShimmerButton
        ref={ref}
        variant={variant}
        disableElevation
        sx={sx}
        {...props}
      >
        {children}
      </StyledShimmerButton>
    );
  }
);

ShimmerButton.displayName = 'ShimmerButton';

export { ShimmerButton, type ShimmerButtonProps };
